/**/
import React from "react"
import { withRouter } from 'react-router-dom'
import { Card, Tabs, Row, Col, Typography, Input, Icon, Button, Table, Spin, Tag, message } from "antd"
import { Auth, API } from "aws-amplify"
import BaseAdmin from "./BaseAdmin"
import moment from 'moment'
import { CSVLink } from 'react-csv'
import { connect } from "react-redux"
import {CustomSpinner} from "../../Components/Spin/CustomSpiner"
import { allState as mapStateToProps, allDispatch as mapDispatchToProps } from "../../Redux/Selectors"
const { Text } = Typography;
const { TabPane } = Tabs;
const { Search } = Input;

class AdminLiteAdministration extends React.Component {


    constructor(props) {
        super(props)
        this.state={
            usuarios:[],
            loading: true
        }
    }

    componentDidMount() {
        Auth.currentSession()
            .then(response => {
                API.get(
                    'test',
                    '/root/admindashboard/adminlites/',
                    {
                        headers: {
                            Authorization: response.getIdToken().getJwtToken()
                        }
                    }
                )
                    .then(response => {
                        if(response){
                            response.forEach(a => {
                                a.plan = `${a.tipo_plan} - ${a.plan_id}`
                            })
                        }
                        this.setState({ loading: false, usuarios: response })
                    })
                    .catch(err => console.log(err))
            })
    }


    render() {
        if (this.state.loading){
            return(
                <BaseAdmin selected='Admin'>
                    <Row type="flex" justify="space-around" align="middle">
                        <Col style={{minHeight:'360px'}}>
                            <Spin indicator={CustomSpinner}/>
                        </Col>
                    </Row>
                </BaseAdmin>
            )
        }

        else {
            let columns = [
                {
                    title: "CUIT",
                    dataIndex: "cuit",
                    key: "cuit",
                },
                {
                    title: "Razón social",
                    dataIndex: "razon_social",
                    key: "razon_social",
                },
                {
                    title: "Email",
                    dataIndex: "email",
                    key: "email",
                },
                {
                    title: "Domicilio",
                    dataIndex: "domicilio_cliente",
                    key: "domicilio",
                },
                {
                    title: "Localidad",
                    dataIndex: "localidad",
                    key: "localidad",
                },
                {
                    title: "Plan",
                    dataIndex: "plan",
                    key: "plan",
                },
                {
                    title: "Acciones",
                    dataIndex: "actions",
                    key: "actions",
                    render: (text, record, index) => {
                        return {
                            children: <Button onClick={() => this.props.history.push("/edit-user-admin-lite/" + record.user_id)}>
                                Editar
                        </Button>
                        }
                    }
                },

            ]

            return (


                <BaseAdmin
                    selected="admin"
                >
                    <Card style={{ marginTop: '10px' }}>
                        <Row>
                            <Col lg={24}>
                                <Table
                                    columns={columns}
                                    dataSource={this.state.usuarios}
                                    pagination={{
                                        showSizeChanger: true,
                                        pageSizeOptions: ['5', '10', '20', '50', '100'],
                                        defaultPageSize: 5,
                                        hideOnSinglePage: true
                                    }}
                                    loading={this.state.loading}
                                    scroll={{ x: "max-content" }}
                                />
                            </Col>
                        </Row>
                    </Card>
                </BaseAdmin>

            );
        }
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(AdminLiteAdministration));
